module.exports = __webpack_public_path__ + "files/roubaix.89288f95c3a66df998231b0c3528be82.pdf";